import { jsx as _jsx } from "react/jsx-runtime";
import { Pagination as MuiPagination, PaginationItem as MuiPaginationItem, } from '@mui/material';
import { styled } from '../../utils';
import { Icon } from '../Icon';
const PaginationItemStyled = styled(MuiPaginationItem)(({ theme }) => ({
    color: theme.palette.primary.main, // Zurich Blue
    '&[type=button]:hover': {
        backgroundColor: theme.palette.groupPrimary.dove, // '#DDE4E3' Dove --> TODO: find correct color #DEE8F3
    },
    '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary.dark, // Dark blue
        },
    },
}));
function PreviousIcon(size) {
    return _jsx(Icon, { variant: "arrow-left-2", fontSize: size || 'medium' });
}
function NextIcon(size) {
    return _jsx(Icon, { variant: "arrow-right-2", fontSize: size || 'medium' });
}
export const Pagination = ({ fontSize, ...props }) => (_jsx(MuiPagination, { renderItem: (item) => (_jsx(PaginationItemStyled, { components: {
            previous: () => PreviousIcon(fontSize),
            next: () => NextIcon(fontSize),
            // TODO: find icons for 'first' and 'last'
        }, ...item })), ...props }));
